<div *ngIf="status">
  <div class="cg-margin-right-sm">
    <cigna-alert
      *ngIf="status === 'APPROVE' || status === 'PARTIAL_APPROVE'"
      class="precert-alert-success"
      type="success"
      [size]="size"
      ><span class="title">{{ PrecertificationStatus[status] }}</span>
    </cigna-alert>
    <cigna-alert
      *ngIf="status === 'PEND' || status === 'VOID' || status === 'MIXED'"
      type="info"
      [size]="size"
      ><span class="title">{{ PrecertificationStatus[status] }}</span>
    </cigna-alert>
    <cigna-alert
      *ngIf="status === 'DENY'"
      type="warning"
      [size]="size"
      class="precert-alert-warning"
      ><span class="title">{{ PrecertificationStatus[status] }}</span>
    </cigna-alert>
  </div>
</div>
